import { LanguageCode, LanguageCodeHelper, mapEnumToRecord, UserRight } from '@biteinc/enums';
import { AbstractModelSchema } from './abstract_model_schema.js';
export const appearanceSchema = {
    displayName: 'Appearance',
    type: 'object',
    fields: {
        ...AbstractModelSchema.fields,
        name: {
            displayName: 'Appearance Name',
            type: 'shortString',
            required: true,
        },
        orgId: {
            type: 'mongoId',
            required: true,
            isHidden: true,
            isReadOnly: true,
        },
        locationId: {
            type: 'mongoId',
            isHidden: true,
            isReadOnly: true,
        },
        orgAppearanceId: {
            type: 'mongoId',
            displayName: 'Parent Appearance',
            biteOnly: true,
            tooltip: {
                text: 'The org level appearance that this appearance should inherit from.',
            },
            conditions: [
                {
                    field: 'locationId',
                    exists: true,
                },
            ],
            ui: 'dropdown',
        },
        customCssBuildId: {
            displayName: 'Custom CSS',
            biteOnly: true,
            type: 'mongoId',
            ui: 'dropdown',
            isNullable: true,
            required: true,
            writeRight: UserRight.BiteSupport,
        },
        customCssVitrineBuildId: {
            displayName: 'Custom CSS Vitrine',
            biteOnly: true,
            type: 'mongoId',
            ui: 'dropdown',
            isNullable: true,
            required: true,
            writeRight: UserRight.BiteSupport,
        },
        customStrings: {
            type: 'map',
            displayName: 'Custom Strings',
            collapse: true,
            biteOnly: true,
            tooltip: {
                text: 'If your key is not there, ask a dev',
            },
            key: {
                type: 'keyString',
                displayName: 'String Key',
                placeholder: 'Add a New String:',
            },
            fields: mapEnumToRecord(LanguageCode, (languageCode) => {
                return {
                    type: 'shortString',
                    displayName: LanguageCodeHelper.name(languageCode),
                };
            }),
        },
    },
};
//# sourceMappingURL=appearance_schema.js.map